import React, { useState } from "react";

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <section id="contact" className="py-16 bg-gray-100 dark:bg-gray-800">
      <div className="container mx-auto px-4 max-w-xl">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800 dark:text-gray-100">
          Contact
        </h2>

        <div className="flex justify-center gap-4 mb-8">
          <a
            href="/SatwikTripathiResume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 border-2 border-gray-900 dark:border-gray-100 rounded-full font-semibold hover:bg-gray-200 dark:hover:bg-gray-700 transition"
          >
            View CV
          </a>
          <a
            href="/SatwikTripathiResume.pdf"
            download
            className="px-6 py-3 border-2 border-gray-900 dark:border-gray-100 rounded-full font-semibold hover:bg-gray-200 dark:hover:bg-gray-700 transition"
          >
            Download CV
          </a>
        </div>

        {submitted ? (
          <p className="text-center font-bold text-gray-800 dark:text-gray-100">
            Thank you! I will get back to you shortly.
          </p>
        ) : (
          <form
            className="flex flex-col gap-4 bg-white dark:bg-gray-700 p-6 rounded-lg shadow"
            action="https://formspree.io/f/xwpqjazr"
            method="POST"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.target;
              const data = new FormData(form);
              fetch(form.action, { method: "POST", body: data, headers: { Accept: "application/json" } })
                .then((res) => (res.ok ? setSubmitted(true) : alert("Error submitting form")))
                .catch(() => alert("Error submitting form"));
            }}
          >
            <input type="text" name="name" placeholder="Your Name" required className="p-3 rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100" />
            <input type="email" name="_replyto" placeholder="Your Email" required className="p-3 rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100" />
            <textarea name="message" rows="4" placeholder="Message" required className="p-3 rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100"></textarea>
            <button type="submit" className="px-6 py-3 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-900 rounded-full hover:bg-gray-700 dark:hover:bg-gray-300 transition font-semibold">
              Send Message
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default Contact;